<template>
  <div v-if="!$store.state.self.TOTPVerified || $store.state.self.TOTPVerifiedModuleUrl != currentModuleUrl">
    <div class="popup">
      <div class="popup-content">
        <h3>Double Authentification requise</h3>
        <hr />
        <div class="form-group">
          <label>Saisie du code de double authentification : </label>
          <input class="form-control" type="text" v-model="inputCode" />
          <!-- Code bien saisi -->
          <div class="alert alert-success" v-if="verificationStatus == 1">
            {{ verificationMessage }}
          </div>
          <!-- Erreur dans code -->
          <div class="alert alert-danger" v-if="verificationStatus == 0">
            {{ verificationMessage }}
          </div>
        </div>
        <button class="btn btn-primary" v-on:click="verifyInputCode()">Valider</button>
      </div>
    </div>
  </div>
</template>

<script>

  import { verifyCode } from "@/utils/mfa";
  import { getCurrentModuleUrl } from "@/utils";

  export default {
    name: "MfaPopup",
    props: [],
    data() {
      return {
        inputCode: "",
        verificationStatus: -1,
        verificationMessage: "",
        currentModuleUrl: "",
      }
    },
    mounted() {
      this.currentModuleUrl = getCurrentModuleUrl();
      if (this.$store.state.self.TOTPVerified && this.$store.state.self.TOTPVerifiedModuleUrl == this.currentModuleUrl)
        this.$emit("authenticated")
    },
    methods: {
      // Vérification du code
      verifyInputCode() {
        if (this.inputCode != null && this.inputCode != "" && this.inputCode.length == 6) {
          verifyCode(this.inputCode).then(r => {
            if (r) {
              this.$emit("authenticated")
              this.verificationMessage = "Double authentification réussie !";
              this.verificationStatus = 1;
            }
            else {
              this.verificationMessage = "Le code saisi est incorect";
              this.verificationStatus = 0;
            }
          })
        }
        else {
          this.verificationMessage = "Le code saisi n'est pas valable !";
          this.verificationStatus = 0;
        }
      }
    }
  }
</script>

<style scoped>
  .popup {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(155, 155, 155, 0.8);
  }

    .popup > .popup-content {
      margin: 70px auto;
      padding: 20px;
      background: #fff;
      border-radius: 5px;
      width: 640px;
      max-height: 80%;
      position: relative;
      overflow-y: scroll;
    }


  .btn-primary {
    background: #A7C13C !important;
    border: #A7C13C !important;
  }


  .alert {
      margin-top: 5px;
      margin-bottom: 0px;
  }

  .btn {
      margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MfaPopup.vue